import LAYOUT from '@/layout/layout';
import moduleLayout from '@/modules/FastLineLite/layout/Layout.vue';

export default [
  {
		path: '/fastline/',
		component: LAYOUT.base,
		name: 'FastLine',
		redirect: {name: 'FastLineSection'},
    children: [
      {
        path: 'pro',
				name: 'FastLineLite',
        component: moduleLayout,
        children: [
					{
						path: '', // Default child route for /fastline/pro
						redirect: { name: 'FastLineLiteAgents' }
					},
          {
            path: 'agents',
            name: 'FastLineLiteAgents',
            component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/views/Agents.vue'),
          },
					{
						path: 'agents/:agent_id',
						name: 'FastLineLiteAgentDetail',
						component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/views/pages/Agent.vue'),
					},
					{
						path: 'datasets',
						name: 'FastLineLiteDatasets',
						component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/views/DataSets.vue'),
					},
					{
						path: 'datasets/create',
						name: 'FastLineLiteDataSetCreate',
						component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/components/DataSet/DocumentCreate.vue'),
					},
					{
						path: 'datasets/:dataset_id',
						name: 'FastLineLiteDataSet',
						component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/views/pages/DataSet.vue'),
						redirect: {name: 'FastLineLiteDataSetDocuments'},
						children: [
							{
								path: 'settings',
								name: 'FastLineLiteDataSetSettings',
								component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/components/DataSet/Settings.vue'),
							},
							{
								path: 'documents',
								name: 'FastLineLiteDataSetDocuments',
								component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/components/DataSet/Documents.vue'),
							},
							{
								path: 'documents/create',
								name: 'FastLineLiteDataSetDocumentCreate',
								component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/components/DataSet/DocumentCreate.vue'),
							},
							{
								path: 'documents/:document_id',
								name: 'FastLineLiteDataSetSegments',
								component: () => import(/* webpackChunkName: 'file-manager-files' */ '@/modules/FastLineLite/components/DataSet/Segments.vue'),
							},
						],
					},
        ],
      },
    ],
  },
];
